export default __webpack_public_path__ + "static/block3-d0b0d651c3172d0b5e3f69e118c5b396.png";